import { render, staticRenderFns } from "./UnknownItem.vue?vue&type=template&id=58adba9e&"
import script from "./UnknownItem.vue?vue&type=script&lang=js&"
export * from "./UnknownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports